import { CustomerStatus } from "../types/customer.type";

/**
 * QR that lets an existing shop sign up to the Gold Bread LINE OA (@lul7001v).
 *
 * Contract: LINE CRM spec "QR ลงทะเบียน LINE สำหรับลูกค้าเก่า" (2026-08-23). The QR only
 * carries a URL into LINE CRM's LIFF app — no API call, no secret, no token on our side.
 * LINE CRM reads the shop's name, branch and route from our database itself, so none
 * of those go into the URL and a printed QR never needs re-issuing when the shop moves
 * route. Same contract as the PWA's `src/utils/lineRegister.ts`.
 */
const LINE_REGISTER_BASE_URL =
  "https://liff.line.me/2011206183-hE4xTtb6/customer/register/existing";

/**
 * `u` is required: `customer.uuid` is stable across master-data versions and
 * unguessable, so it doubles as the secret. `c` is only for a human to read and as
 * LINE CRM's fallback — `customer_code` is not unique across branches, which is why
 * it can never stand in for `u`.
 */
export function buildLineRegisterUrl(
  customerUuid: string,
  customerCode?: string | null,
): string {
  const params = new URLSearchParams({ u: customerUuid });
  const code = customerCode?.trim();
  if (code) params.set("c", code);
  return `${LINE_REGISTER_BASE_URL}?${params.toString()}`;
}

/**
 * LINE CRM refuses a disabled shop ("ร้านค้านี้ถูกระงับ"), so no QR is offered for one.
 * Compared against 'disable' rather than equal to 'enable': legacy masters can carry a
 * NULL status and are still active shops.
 */
export function canRegisterLine(status?: CustomerStatus | null): boolean {
  return status !== "disable";
}
